module.exports = __webpack_public_path__ + "static/media/WEB-pc_01.227dde17.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/pc/WEB-pc_01.png
// module id = 153
// module chunks = 0